import React from "react";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useIntl } from "react-intl";

import useChartConfig from "./useChartConfig";

interface Props {
  className?: string;
  unverifiedCount?: number;
  verifiedCount: number;
}

const PieChart: React.FC<Props> = ({ className, unverifiedCount, verifiedCount }) => {
  const intl = useIntl();
  const chartConfig = useChartConfig(verifiedCount, unverifiedCount, intl);

  return (
    <HighchartsReact
      containerProps={{ className }}
      highcharts={Highcharts}
      isPureConfig
      options={chartConfig}
    />
  );
};

export default PieChart;
